const mutations = {
  SET_SEL_USER (state, user) {
    state.selUser = user
  },
  SET_INITIATOR_USER (state, user) {
    state.initiator = user
  },
  CLEAR_INITIATOR_USER (state) {
    state.initiator = null
    localStorage.removeItem('initiator_id')
  }
}
export default mutations
